<mat-dialog-content class="notifications-container">
    <!--Modal Header Section-->
    <div class="header-content-wrapper">

        <div class="header-content">
            <h2 class="header-tile">{{ "NOTIFICATIONS" | translate }} ({{ notificationServiceInfos.length }})</h2>
            <button mat-icon-button *ngIf="isEnabledMoreBtn" [matMenuTriggerFor]="moreNotification"
                    #moreMenuTrigger="matMenuTrigger" matTooltip="{{'MORE_NOTIFICATIONS' | translate}}"
                    matTooltipPosition="left"
                    class="more-btn" (click)="$event.stopPropagation()">
                <mat-icon>more_horiz</mat-icon>
            </button>
        </div>
        <div class="notification-progress-bar">
            <mat-progress-bar  mode="indeterminate" *ngIf="isLoadingNotification" ></mat-progress-bar>
        </div>
    </div>

    <!--Value Content section-->
    <div class="value-content-wrapper">

        <div *ngFor="let section of notificationServiceInfos | NotificationsInfoPipe">
            <div class="notification-section" *ngIf="section.values.length">

                <h3 class="section-title"> {{ section.level == 'DAYS_AGO' ? 2 : '' }} {{ section.level | translate }}</h3>

                <div class="notification-list-container">
                    <div class="notification-item" *ngFor="let item of section.values">
                        <mat-list class="notification-card" [ngClass]="{ 'unread-notification': !item.IsRead }">
                            <mat-list-item (click)="onSelectNotification($event, item)">
                                <div class="notification-details">
                                    <div matLine class="notification-timestamp font-size-14"
                                         [ngClass]="{ 'unread-fw': !item.IsRead }"
                                         fxLayout="row"
                                         fxLayoutAlign="start center">
                                        <mat-icon class="timestamp-icon font-size-14">date_range</mat-icon>
                                        <span class="time">{{ section.level != 'DAYS_AGO' ? item.Time : item.CreateDate | pcxDateFormate: true }}</span>
                                    </div>
                                    <div class="notification-message font-size-14" matLine fxLayout="row"
                                         fxLayoutAlign="start center">
                                        <mat-icon class="status-icon font-size-14" [ngClass]="{
                                            'success-icon': item.ActionStatus === 'SUCCESS',
                                            'error-icon': item.ActionStatus === 'FAILED',
                                            'warning-icon': item.ActionStatus === 'PENDING'
                                        }">{{ item.ActionStatus === 'SUCCESS' ? 'check_circle' : item.ActionStatus === 'FAILED' ? 'error' : 'warning' }}
                                        </mat-icon>
                                        <span class="message " [ngClass]="{ 'unread-fw': !item.IsRead }">
                                            {{ item.ActionType + "_" + item.ActionStatus | TranslationFormatterPipe : "NOTIFICATION" | translate }}
                                        </span>

                                    </div>
                                </div>
                            </mat-list-item>
                        </mat-list>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="notificationServiceInfos.length == 0">
            <div class="w-100-p">
                <div fxLayout="column" class="w-100-p no-notification-wrapper" fxLayoutAlign="center center">
                    <img src="assets/images/select-mailbox.svg" alt="" />
                    <p class="no-notification-text" id="am-1267">{{ "NO_NOTIFICATIONS_FOUND" | translate }}</p>
                </div>
            </div>
        </div>

    </div>

    <mat-menu #moreNotification="matMenu" [overlapTrigger]="false" class="more-btn-wrapper">
        <button mat-menu-item id="am-1364" (click)="onClickMarkAsAllRead($event)" [disabled]="!isEnabledMarkAsReadAllBtn"
                matTooltip="{{'MARK_ALL_AS_READ_NOTIFICATIONS' | translate}}"
                matTooltipPosition="left">
            <mat-icon>done_all</mat-icon>
            <span>{{ "MARK_ALL_AS_READ_NOTIFICATIONS" | translate }}</span>
        </button>

        <button mat-menu-item id="am-1365" (click)="onClearAllNotifications($event)" [disabled]="!clearAllBtnEnabled"
                matTooltip="{{'CLEAR_ALL_NOTIFICATIONS' | translate}}"
                matTooltipPosition="left">
            <mat-icon>clear_all</mat-icon>
            <span>{{ "CLEAR_ALL_NOTIFICATIONS" | translate }}</span>
        </button>
    </mat-menu>
</mat-dialog-content>